<div class="fixed top-0 right-0 left-0 flex items-start justify-center bg-black bg-opacity-50 min-h-screen z-50">
    <div class="relative p-4 mt-5 w-full max-w-md bg-white rounded-lg shadow">
        <button type="button" mat-dialog-actions (click)="dialogRef.close(false)"
            class="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
            <span class="sr-only">Close modal</span>
        </button>
        <div class="p-4 md:p-5 text-center">
            <svg
            class="mx-auto mb-4 text-[#bfbfbf] w-12 h-12"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
     
                <h3 class="mb-5 text-lg text-black font-bold">Are you sure you want to delete this
                    {{ data.name }}?</h3>
                <div class="space-x-6">
                    <button mat-dialog-actions type="button"  (click)="deleteUser()"
                    class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] w-fit self-center text-white font-semibold rounded-[1.5rem] text-lg px-6 py-1.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-50"
                    >
                        Yes, I'm sure
                    </button>
                    <button mat-dialog-actions type="button" (click)="dialogRef.close(false)"
                    class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] w-fit self-center text-white font-semibold rounded-[1.5rem] text-lg px-6 py-1.5 text-center bg-tl-red focus:outline-none disabled:opacity-50"
                    >No,
                        cancel</button>
                </div>
           
        </div>
    </div>
</div>
